module.exports = __webpack_public_path__ + "static/Akebia-Global-Medical-Education-Grant-Application-f61327e78ae1672788f49decf9ec3a03.pdf";